export const ADMIN_EMAILS = [
  "naveenbadhan27@gmail.com",
];